const MuiInput = {
  disableUnderline: true
};
export default MuiInput;